import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { MenuDataType } from "services/menus/types";
import { GeneralDataTypes } from "services/systems/types";

type MessageNotify = {
  isOpen: boolean;
  title: string;
  message: string;
  type: "warning" | "success",
};

interface SystemState {
  lang: string;
  data?: GeneralDataTypes;
  menus?: MenuDataType[];
  translationCurrentPage?: TranslationPage;
  messageNotify: MessageNotify;
}

const initialState: SystemState = {
  lang: "",
  data: undefined,
  messageNotify: {
    isOpen: false,
    title: "",
    message: "",
    type: "success",
  },
};

const systemSlice = createSlice({
  name: "system",
  initialState,
  reducers: {
    setLanguage(state, action: PayloadAction<string>) {
      state.lang = action.payload;
    },
    setSystem(state, action: PayloadAction<GeneralDataTypes | undefined>) {
      state.data = action.payload;
    },
    setMenus(state, action: PayloadAction<MenuDataType[] | undefined>) {
      state.menus = action.payload;
    },
    setTranslationCurrentPage($state, action: PayloadAction<TranslationPage | undefined>) {
      $state.translationCurrentPage = action.payload;
    },
    setMessageNotify($state, action: PayloadAction<MessageNotify>) {
      $state.messageNotify = action.payload;
    },
  },
});

export const {
  setLanguage,
  setSystem,
  setMenus,
  setTranslationCurrentPage,
  setMessageNotify,
} = systemSlice.actions;
export default systemSlice.reducer;
